(function () {
    'use strict';

    var element = document.querySelector('meta[name="gmap-api-key"]');
    var gmapApiKey = element && element.getAttribute("content");

    angular
        .module('szallodak-map', ['uiGmapgoogle-maps'])
        .config(function (uiGmapGoogleMapApiProvider) {
            uiGmapGoogleMapApiProvider.configure({
                key: gmapApiKey,
                v: '3.20', //defaults to latest 3.X anyhow
                libraries: 'geometry,visualization,places',
                language: 'hu'
            });
        });
})();
